export default {"src":"/planos/_next/static/media/equifax-megaphone.9d28eadf.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};